export const BACKGROUND_COLOR = {
  White: 'WHITE',
  'Off white': 'OFF_WHITE',
};
